import { render } from "./Thanks.vue?vue&type=template&id=2faf5cf1&scoped=true"
import script from "./Thanks.vue?vue&type=script&lang=js"
export * from "./Thanks.vue?vue&type=script&lang=js"

import "./Thanks.vue?vue&type=style&index=0&id=2faf5cf1&scoped=true&lang=css"

import exportComponent from "/home/runner/work/leadsbroker-anketa/leadsbroker-anketa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2faf5cf1"]])

export default __exports__